import { Icon } from "./Icon";

interface EmptyStateProps {
  loading: boolean;
  error: string;
  onOpenFiles: () => void;
  onOpenFolder: () => void;
  onLoadDemo: () => void;
}

const STEPS = [
  { icon: "upload", title: "画像を開く", text: "ドロップ・選択・貼り付け" },
  { icon: "pen", title: "隠したい所をなぞる", text: "ペン・図形・多角形" },
  { icon: "download", title: "ダウンロード", text: "位置情報も自動で削除" },
] as const;

export function EmptyState({
  loading,
  error,
  onOpenFiles,
  onOpenFolder,
  onLoadDemo,
}: EmptyStateProps) {
  return (
    <main className="empty-state">
      <h1>写真の顔や個人情報を、かんたんにモザイク</h1>
      <p className="empty-lead">画像はアップロードされず、この端末の中だけで処理されます。</p>

      <button
        className="drop-zone"
        type="button"
        disabled={loading}
        onClick={onOpenFiles}
      >
        <span className="drop-zone-icon" aria-hidden="true">
          <Icon name="image" size={30} />
        </span>
        <strong>{loading ? "読み込んでいます…" : "画像を選ぶ"}</strong>
        <span>またはここにドラッグ＆ドロップ・クリップボードから貼り付け</span>
        <span className="format-note">PNG・JPEG・WebP・BMP（最大 8192px）</span>
      </button>

      {error && (
        <p className="empty-error" role="alert">
          {error}
        </p>
      )}

      <div className="empty-actions">
        <button className="secondary-button" type="button" disabled={loading} onClick={onOpenFolder}>
          <Icon name="folder" size={18} />
          フォルダをまとめて開く
        </button>
        <button className="quiet-button" type="button" disabled={loading} onClick={onLoadDemo}>
          サンプル画像で試す
        </button>
      </div>

      <ol className="empty-steps">
        {STEPS.map((step, index) => (
          <li key={step.title}>
            <span className="empty-step-icon" aria-hidden="true">
              <Icon name={step.icon} size={18} />
            </span>
            <span>
              <strong>
                {index + 1}. {step.title}
              </strong>
              <small>{step.text}</small>
            </span>
          </li>
        ))}
      </ol>
    </main>
  );
}
